<p-toast></p-toast>
<div class="mat-elevation-z8">
  <p-footer>
    <div class="ui-helper-clearfix" style="margin-left: 85%">
      <button
        type="button"
        pButton
        style="float: left"
        (click)="showDialogToAdd()"
        label="Add Api Key"
      ></button>
    </div>
  </p-footer>
  <br /><br />

  <p-dialog
    header="Add API Keys"
    *ngIf="createDialog"
    [(visible)]="createDialog"
    [responsive]="true"
    showEffect="fade"
    (onHide)="Cancel()"
    [modal]="true"
    [style]="{ width: '800px' }"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4">
          <label for="provider_token_type"><b>Provider Service:</b></label>
        </div>
        <div class="ui-g-12 ui-md-8">
          <p-dropdown
            id="provider_token_type"
            [options]="providerServices"
            (onChange)="fetchServiceSources($event)"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="selectedProviderChosen"
            name="provider_token_type"
            placeholder="Select"
            #providerServiceDropdown="ngModel"
            [required]="true"
          >
          </p-dropdown>
          <div
            *ngIf="
              providerServiceDropdown.invalid &&
              (providerServiceDropdown.dirty || providerServiceDropdown.touched)
            "
            class="alert alert-danger"
          >
            Provider Service is required.
          </div>
        </div>
      </div>

      <div *ngIf="tokenTypes.length > 0">
        <div *ngFor="let token of tokenTypes" class="ui-g">
          <div class="ui-g-12 ui-md-4">
            <label for="{{ token.value }}"
              ><b>{{ token.label }}:</b></label
            >
          </div>
          <div class="ui-g-12 ui-md-8">
            <input
              type="text"
              pInputText
              id="{{ token.value }}"
              name="{{ token.value }}"
              placeholder="Enter {{ token.label }}"
              [(ngModel)]="tokenValues[token.value]"
              required
            />
            <div *ngIf="!tokenValues[token.value]" class="alert alert-danger">
              {{ token.label }} is required.
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-12 text-align-center">
          <button
            type="button"
            pButton
            label="Submit"
            [disabled]="isFormInvalid()"
            (click)="OnSubmitAPIKeys()"
          ></button>
        </div>
      </div>
    </div>
  </p-dialog>

  <div class="mat-elevation-z8">
    <div class="table-responsive text-center justify-content-center">
      <p-table
        #dt1
        dataKey="id"
        [value]="submittedApiKeys"
        [rows]="10"
        [paginator]="true"
        [showCurrentPageReport]="true"
        [scrollable]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        [globalFilterFields]="['provider', 'tokenType', 'apiKey']"
      >
        <ng-template pTemplate="header">
          <tr>
            <!-- <th pSortableColumn="provider">Provider<p-sortIcon field="provider"></p-sortIcon></th> -->
            <th
              style="width: auto; text-align: center"
              pSortableColumn="tokenType"
            >
              Token Type<p-sortIcon field="tokenType"></p-sortIcon>
            </th>
            <!-- <th pSortableColumn="apiKey">API Key<p-sortIcon field="apiKey"></p-sortIcon></th> -->
            <!-- <th style="width:auto;text-align: center;">Actions</th> -->
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-apiKey>
          <tr>
            <!-- <td>{{ apiKey.provider }}</td>
                    <td>{{ apiKey.tokenType }}</td> -->
            <td style="width: auto; text-align: center">
              {{ apiKey.tokenType }}
            </td>
            <!-- <td style="width:auto;text-align: center;">
                        <button pButton type="button" icon="pi pi-trash" (click)="deleteApiKey(apiKey)"></button>
                    </td> -->
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p>
  Please use the following unique Stripe Webhook URL <a [href]="webhookUrl">{{ webhookUrl }}</a> and add your Stripe API KEY and Webhook signing key above.
</p>
